import React from 'react'
import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import {
  CopyOutlined,
  SwapOutlined,
  DeleteOutlined,
  GlobalOutlined,
  TeamOutlined,
  LockOutlined
} from '@ant-design/icons'
import './SelectionBar.scss'

const { Text } = Typography

const SelectionBar = ({
  isDownloading,
  selectedItems,
  handleDelete,
  handleBulkCopy,
  handleBulkMove,
  defaultQuery
}) => {
  const { t } = useTranslation()

  return (
    <div className="selection-bar">
      <Text>{t('v5:items_selected', { count: selectedItems.length })}</Text>
      <div className="selection-actions">
        <Button
          icon={<CopyOutlined />}
          onClick={handleBulkCopy}
          disabled={isDownloading}
        >
          {t('v4:copy')}
        </Button>
        <Button
          icon={<SwapOutlined />}
          onClick={handleBulkMove}
          disabled={isDownloading || defaultQuery.isDownload}
        >
          {t('v4:move')}
        </Button>
        <Button
          icon={<DeleteOutlined />}
          danger
          disabled={isDownloading}
          onClick={() => {
            handleDelete()
          }}
        >
          {t('buttons:delete')}
        </Button>
      </div>
    </div>
  )
}

export default SelectionBar
